import { IForm } from '../IForm.types';
import { ButtonForm } from './ButtonForm';
import { InputCheckboxForm } from './InputCheckboxForm';
import { InputCheckboxGroupForm } from './InputCheckboxGroupForm';
import { InputIntegerForm } from './InputIntegerForm';
import { InputNumberForm } from './InputNumberForm';
import { InputRadioForm } from './InputRadioForm';
import { InputSelectForm } from './InputSelectForm';
import { InputStringForm } from './InputStringForm';
import { TextForm } from './TextForm';
const itemMap = {
  number_integer: InputIntegerForm,
  number: InputNumberForm,
  select: InputSelectForm,
  checkbox: InputCheckboxForm,
  radio: InputRadioForm,
  text: TextForm,
  checkbox_group: InputCheckboxGroupForm,
  string: InputStringForm,

};

export class FormIoBuilder {
  type = 'form';
  display = 'form';
  components = [];
  noAlerts: true;
  title: string;
  constructor(form: IForm) {
    this.title = form.title;
    form.fields.forEach((field) => {
      const Component = itemMap[field.parameterType.toLowerCase()];
      if (Component) {
        this.components.push(new Component(field));
      } else {
        console.error(`field type ${field.parameterType} not found`);
      }
    });
    form.buttons.forEach((button) =>
      this.components.push(new ButtonForm(button))
    );
  }
}
